import { render, staticRenderFns } from "./EtfPerformanceSection.vue?vue&type=template&id=3aa3f19b&scoped=true"
import script from "./EtfPerformanceSection.vue?vue&type=script&lang=ts"
export * from "./EtfPerformanceSection.vue?vue&type=script&lang=ts"
import style0 from "./EtfPerformanceSection.vue?vue&type=style&index=0&id=3aa3f19b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3f19b",
  null
  
)

export default component.exports